<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span class="cardHeader">{{ subName }}信息</span>
            </div>

            <el-row>
              <el-col :span="24">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column prop="subjectId" label="主键" width="60" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.subjectId == 0">新增</span>
                      <span v-if="scope.row.subjectId > 0">{{ scope.row.subjectId }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" :label="subName + '名称'">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name" :placeholder="'请输入' + subName + '名称'"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column prop="orderNum" label="排序">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.orderNum" :min="1"></el-input-number>
                    </template>
                  </el-table-column>

                  <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                      <el-switch v-model="scope.row.status" active-value="1" active-text="禁用" inactive-value="0" inactive-text="正常"> </el-switch>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button width="100%" type="primary" v-if="scope.row.subjectId == 0" @click="insertRow(scope.row)">确认新增</el-button>
                      <div v-if="scope.row.subjectId > 0">
                        <el-button size="small" @click="updateRow(scope.row)">更新</el-button>

                        <el-button size="small" @click="delRow(scope.row)">删除</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="10" class="pageRight">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span class="cardHeader">{{ subName }}人员设置</span>
            </div>
            <SubjectUser></SubjectUser>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import SubjectUser from "./SubjectUser.vue"
import subjectApi from "@/api/subject"

export default {
  components: { PageHeader, SubjectUser },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [
        { path: "", title: "基础数据" },
        { path: "", title: (process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目") + "管理" },
      ],
      tableData: [],
      form: {},
      form2: {},
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      subjectApi.getList().then((res) => {
        this.tableData = res.data
        this.tableData.push({
          subjectId: 0,
          name: "",
          orderNum: 1 + res.data.length,
          status: 0,
        })
      })
    },

    insertRow(row) {
      let model = {
        name: row.name,
        orderNum: parseInt(row.orderNum),
        status: parseInt(row.status),
      }
      subjectApi.insert(model).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "添加成功",
            type: "success",
          })
          this.loadData()
        } else {
          this.$notify.error({
            title: "错误",
            message: "添加失败" + res.msg,
          })
        }
      })
    },

    updateRow(row) {
      let model = {
        subjectId: parseInt(row.subjectId),
        name: row.name,
        orderNum: parseInt(row.orderNum),
        status: parseInt(row.status),
      }
      subjectApi.update(model).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "更新成功",
            type: "success",
          })
          this.loadData()
        } else {
          this.$notify.error({
            title: "错误",
            message: "更新失败" + res.msg,
          })
        }
      })
    },

    delRow(row) {
      subjectApi.remove(row.subjectId).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
          })
          this.loadData()
        } else {
          this.$notify.error({
            title: "错误",
            message: "删除失败" + res.msg,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
</style>
